import { cn } from "@/utils/styles";
import { useField, useFormikContext } from "formik";
import { SignupTick } from "../SignupTick/SignupTick";

type SignupRadioFieldProps = {
  name: string;
  value: string;
  label: string;
};

export const SignupRadioField: React.FC<SignupRadioFieldProps> = ({ name, value, label }) => {
  const { setFieldValue } = useFormikContext();
  const [field] = useField(name);
  const active = field.value === value;

  return (
    <div
      className={cn(
        "label-small flex flex-row items-center rounded  border	px-4 py-3 text-white",
        active ? "border-gray-dark-1200 bg-gray-dark-1400" : "cursor-pointer border-gray-dark-900"
      )}
      onClick={() => {
        setFieldValue(name, value);
      }}
    >
      <span>{label}</span>
      <div className="flex-1"></div>
      <SignupTick active={active} />
    </div>
  );
};
